import { ResponsiveObject } from 'react-slick';

export const carouselResponsive: ResponsiveObject[] = [
    { breakpoint: 1330, settings: { slidesToShow: 3, slidesToScroll: 3 } },
    { breakpoint: 1007, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 683, settings: { slidesToShow: 1, slidesToScroll: 1 } }
];
